/**
 * Entry point for the site's static assets
 */
'use strict';

/**
 * Dependencies
 */
var $ = require( 'jquery' );

/**
 * Initialize JS on document ready
 */
$( document ).ready( function () {
	// Site JS
	require( './site' );

	// Sections JS
	var req = require.context( '../../../sections/', true, /\.js$/ );
	req.keys().forEach( req );
} );

/**
 * Styling
 */

// Site styles
require( '../scss/screen.scss' );

// Sections styles
var req = require.context( '../../../sections/', true, /\.scss$/ );
req.keys().forEach( req );



//////////////////
// WEBPACK FOOTER
// ./www/app/content/themes/rikssalsstiftelsen/static/src/js/bootstrap.js
// module id = 0
// module chunks = 0